const FLOATING_SURVEY_GAP = 8;

export function getFloatingSurveyScrollReserve(
  isVisible: boolean,
  measuredHeight: number,
): number {
  return isVisible && measuredHeight > 0
    ? measuredHeight + FLOATING_SURVEY_GAP
    : 0;
}
